import { FC, useContext } from 'react';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import Page from '../page/LiftReportPage';
import getSelectedLiftReportChart from '../../utility/getSelectedLiftReportChart';

type Props = { className?: string };

const LiftReportPage: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  const liftReportLiftUp = getSelectedLiftReportChart('LIFT_UP', state);
  const liftReportCoverage = getSelectedLiftReportChart('IMPROVEMENT_RATE', state);
  const liftReportIndex = getSelectedLiftReportChart('CVR', state);

  return (
    <Page
      organization={state.lastAccessedOrganization.item}
      liftReportLiftUp={liftReportLiftUp}
      liftReportCoverage={liftReportCoverage}
      liftReportIndex={liftReportIndex}
      goalId={state.selectedGoalId.data}
      liftReportChartSetting={state.liftReportChartSetting.period}
      liftReportLoading={state.liftReports.fetching > 0 || state.lastAccessedOrganization.fetching > 0}
      onMount={() => {
        dependency.liftReportUsecase.prepareLiftReportCharts();
      }}
      onUnmount={() => {
        dependency.liftReportUsecase.dispose();
      }}
      className={className}
    />
  );
};

export default LiftReportPage;
